export class EventSettingTranslation
{
    id: number;
    locale: string;
    imprint: string;
}
